import React, { useState } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Container,
  Fade,
} from "@mui/material";
import GoldProduct from "./getProducts/goldProducts";
import DiamondProduct from "./getProducts/diamondProducts";

// Tab Panel bileşeni
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`product-tabpanel-${index}`}
      aria-labelledby={`product-tab-${index}`}
      {...other}
    >
      <Fade in={value === index}>
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      </Fade>
    </div>
  );
}

const Index = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container 
      maxWidth={false} 
      disableGutters={true}
      sx={{ 
        pt: { xs: 2, sm: 8 }, 
        px: { xs: 0, sm: 2, md: 4 },
        overflow: 'hidden'
      }}
    >
      <Box sx={{
        width: '100%'
      }}>
        <Typography
          variant="h5"
          component="h1"
          sx={{
            mb: { xs: 2, sm: 4 },
            fontWeight: 'bold',
            textAlign: 'center',
            color: 'primary.main',
            px: { xs: 2, sm: 0 },
          }}
        >
          Ürünler
        </Typography>

        <Paper
          elevation={0}
          sx={{
            bgcolor: 'background.paper',
            borderRadius: { xs: 0, sm: 2 },
            overflow: 'hidden',
            width: '100%'
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              '& .MuiTab-root': {
                py: 2,
                fontSize: '1rem',
              },
              '& .Mui-selected': {
                fontWeight: 'bold',
              },
              padding: { xs: 0, sm: 2, md: 4 },
            }}
          >
            <Tab
              iconPosition="start"
              label="Altın Ürünleri"
              sx={{
                '&:hover': {
                  bgcolor: 'primary.light',
                  color: 'primary.dark',
                },
                transition: 'all 0.3s ease',
              }}
            />
            <Tab
              iconPosition="start"
              label="Döviz Ürünleri"
              sx={{
                '&:hover': {
                  bgcolor: 'primary.light',
                  color: 'primary.dark',
                },
                transition: 'all 0.3s ease',
              }}
            />
          </Tabs>

          <TabPanel value={value} index={0}>
            <Box sx={{ 
              width: { xs: '80%', sm: '80%', md: '100%' , lg: '100%' },
              px: { xs: 0, sm: 0 },
              overflow: 'hidden',
              mx: 'auto'

            }}>
              <GoldProduct />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box sx={{ 
              width: '100%', 
              px: { xs: 0, sm: 0 },
              overflow: 'hidden'
            }}>
              <DiamondProduct />
            </Box>
          </TabPanel>
        </Paper>
      </Box>
    </Container>
  );
};

export default Index;
